import { Type } from "../enum/type";

export interface Authority {
    id: string,
    code: Type,
    authority: string;
}
